import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PoNotificationService } from '@po-ui/ng-components';
import { HttpClient } from '@angular/common/http';
import { RpaService } from '../../../core/rpa/rpa.service';
import { EmpresaRpaDto } from '../../../models/Empresas/empresa-rpa-dto';
import { environment } from '../../../../environments/environment';
import { COMPETENCIA_RELATORIO_OPTIONS } from '../rpa-relatorio-pendencias.config';

@Component({
   selector: 'app-rpas',
   templateUrl: './rpas-relatorio.component.html',
   styleUrls: ['./rpas-relatorio.component.css'],
   standalone: false
})
export class RPAsRelatorioComponent implements OnInit, OnDestroy {
   tipoCertidao: string = '';
   cidade: string = 'SANTO ANDRE';
   competencia: string = '';
   tipoFiltro: string = '0';
   cidadesOptions: Array<{ label: string; value: string }> = [];
   readonly competenciaOptions = COMPETENCIA_RELATORIO_OPTIONS;

   selectEmpresa: any;
   loading = false;
   editClient: any;
   readonly serviceApi = environment.apiUrl + '/v1/empresas';

   constructor(
      private readonly rpaService: RpaService,
      private readonly poNotificationService: PoNotificationService,
      private readonly http: HttpClient
   ) { }

   ngOnDestroy(): void {
   }

   ngOnInit(): void {
      this.loadCidades();
   }

   public onChangeTipocertidao(event: string) {
      this.tipoCertidao = event;
   }

   public onChangeCompetencia(event: string) {
      this.competencia = event;
   }

   public onChangeCidade(event: string) {
      this.cidade = event;
   }

   private loadCidades() {
      this.http.get<string[]>(`${this.serviceApi}/cidades`).subscribe({
         next: (cidades) => {
            this.cidadesOptions = cidades.map(cidade => ({
               label: cidade,
               value: cidade
            }));
            if (this.cidadesOptions.find(c => c.value === 'SANTO ANDRE')) {
               this.cidade = 'SANTO ANDRE';
            } else if (this.cidadesOptions.length > 0) {
               this.cidade = this.cidadesOptions[0].value;
            }
         },
         error: (error) => {
            this.poNotificationService.error('Erro ao carregar lista de cidades.');
         }
      });
   }

   public geraReportEmpresaRpa() {
      if (!this.tipoFiltro || this.tipoCertidao === '' || this.competencia === '') {
         this.poNotificationService.warning('Preencha todos os campos para gerar o relatório.');
         return;
      }

      this.empresaRpaServiceReport(this.tipoCertidao, this.cidade, this.competencia, this.tipoFiltro);
   }

   private empresaRpaServiceReport(typeCnd: string, cidade: string, competencia: string, typeCndFiltred: string) {
      this.loading = true;
      this.rpaService.requestEmpresasRpa(typeCnd, cidade, competencia, typeCndFiltred, '0').subscribe(data => {
         this.exportToCsv(data, 'empresas_rpa');
         this.downloadArquivosLote(data);
      }, error => {
         this.loading = false;
         this.poNotificationService.error('Erro ao gerar relatório.');
      });
   }

   private exportToCsv(data: EmpresaRpaDto[], fileName: string): void {
      if (data.length === 0) {
         this.poNotificationService.warning('Nenhum dado encontrado para exportação.');
         return;
      }

      const csvData = this.convertToCsv(data);
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${fileName}_${new Date().getTime()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   }

   private convertToCsv(data: EmpresaRpaDto[]): string {
      const header = Object.keys(data[0]).join(';') + '\n';
      const rows = data.map(row => Object.values(row).join(';')).join('\n');
      return header + rows;
   }

   downloadArquivosLote(data: EmpresaRpaDto[]) {
      const objectNames = this.getRpaUrls(data);
      if (objectNames.length === 0) {
         this.poNotificationService.warning('Nenhum arquivo encontrado para download.');
         this.loading = false;
         return;
      }

      const batches = this.chunkArray(objectNames, 100);
      // Processar os lotes sequencialmente
      this.processBatches(batches);
   }

   private chunkArray(array: string[], size: number): string[][] {
      return Array.from({ length: Math.ceil(array.length / size) }, (_, i) =>
         array.slice(i * size, i * size + size)
      );
   }

   private getRpaUrls(data: EmpresaRpaDto[]): string[] {
      return data.map(item => item.rpaUrl || '')
         .filter(url => url && url.trim() !== '');  // Retorna a propriedade rpaUrl ou uma string vazia caso seja undefined
   }

   private async processBatches(batches: string[][]) {
      this.loading = true;

      for (let i = 0; i < batches.length; i++) {
         try {
            this.rpaService.baixarZipLoteStream(batches[i]).subscribe(blob => {
               const url = window.URL.createObjectURL(blob);
               const a = document.createElement('a');
               a.href = url;
               a.download = `documentos_${new Date().toISOString()}-${i}.zip`;
               a.click();
               window.URL.revokeObjectURL(url);
               this.loading = false;
            });
         } catch (error) {
            this.poNotificationService.error(`Erro ao processar o lote ${i + 1}.`);
         }
      }

      this.loading = false;
      this.poNotificationService.success('Download concluído com sucesso!');
   }
}
